const validate = values => {
    const errors = {estado: ''};

    if (!values.estado) {
        errors.estado = 'Escoja un estado';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/clientes/validate.ts